import React from "react";
import SSOLoginForgotPanel from "./ssoLoginCard/SSOLoginForgotPanel";
import SSOLoginMainPanel from "./ssoLoginCard/SSOLoginMainPanel";
import { useSSOLoginCard } from "./ssoLoginCard/useSSOLoginCard";

/** Customer / platform sign-in (email, IdP picker, password, forgot password, SSO). */
export default function SSOLoginCard({ brand, isAdminAccess = false, customerKey, onLogin }) {
  const view = useSSOLoginCard({ brand, isAdminAccess, customerKey, onLogin });

  if (view.forgotStep === "request" || view.forgotStep === "confirm") {
    return <SSOLoginForgotPanel {...view} />;
  }

  return <SSOLoginMainPanel {...view} />;
}
